import React from "react";
import { Home } from "lucide-react";
import { UI } from "../designSystem";

// "Meu diário" -- agrega, em uma única tela, as reflexões escritas (aba
// "Registrar" de cada dia devocional) e os trechos marcados/destacados ao
// longo de todas as trilhas. Puramente apresentacional: quem monta a lista
// de entradas (varrendo localStorage por trilha/dia) é o componente pai.
export default function DiaryScreen({
  entries,
  onOpenEntry,
  setScreen,
  renderBottomNav,
  isMobile,
  isTablet,
  isDesktop,
  styles
}) {
  const {
    containerStyle,
    fixedTopBarStyle,
    pageContentStyle,
    eyebrowStyle,
    h1Style,
    softPanelStyle,
    buttonReset
  } = styles;

  return (
    <div style={containerStyle}>
      <div style={fixedTopBarStyle}>
        <button onClick={() => setScreen("main")} style={{ ...buttonReset, fontSize: 24, color: "#9CA3AF", marginRight: 20 }}>←</button>
        <span style={{ fontSize: 13, fontWeight: 700, color: "#FFFFFF", textTransform: "uppercase", letterSpacing: 2 }}>Meu diário</span>
        <a href="/" aria-label="Voltar para o site institucional" title="Início do site" style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 999, color: "#9CA3AF", textDecoration: "none", flexShrink: 0 }}>
          <Home size={18} />
        </a>
      </div>

      <div style={pageContentStyle}>
        <p style={{ ...eyebrowStyle, color: "#c7ced9" }}>Jornada pessoal</p>
        <h1 style={{ ...h1Style, fontSize: isDesktop ? 36 : isTablet ? 30 : 25, margin: "0 0 10px", color: "#FFFFFF", fontWeight: 900 }}>Suas anotações e marcações</h1>
        <p style={{ fontSize: 14, color: "#9CA3AF", margin: "0 0 22px", lineHeight: 1.55, maxWidth: 620 }}>
          Tudo o que você escreveu na aba "Registrar" e todos os trechos marcados nos devocionais aparecem aqui, agrupados por trilha e dia.
        </p>

        {entries.length === 0 && (
          <div style={{ ...softPanelStyle, padding: isTablet ? "34px" : "24px", textAlign: "center" }}>
            <p style={{ margin: 0, fontSize: 15, color: "#D1D5DB", lineHeight: 1.6 }}>
              Ainda não há nada por aqui. Escreva uma reflexão ou marque um trecho em algum devocional para começar seu diário.
            </p>
          </div>
        )}

        {entries.length > 0 && (
          <div style={{ display: "grid", gap: 14 }}>
            {entries.map((entry) => (
              <button
                key={`${entry.trailId}_${entry.day}`}
                onClick={() => onOpenEntry(entry)}
                style={{
                  ...buttonReset,
                  ...softPanelStyle,
                  display: "block",
                  textAlign: "left",
                  padding: isTablet ? "22px 24px" : "18px",
                  borderLeft: `4px solid ${entry.trailColor || UI.brand}`,
                  cursor: "pointer"
                }}
              >
                <p style={{ margin: "0 0 6px", fontSize: 11, letterSpacing: 1.1, textTransform: "uppercase", fontWeight: 800, color: entry.trailColor || UI.brand }}>
                  {entry.trailTitle || "Trilha"} • Dia {entry.day}
                </p>
                <h3 style={{ margin: "0 0 10px", fontSize: 17, color: "#FFFFFF", fontWeight: 800 }}>{entry.dayTitle}</h3>
                {entry.reflection && (
                  <p style={{ margin: "0 0 8px", fontSize: 14, color: "#D1D5DB", lineHeight: 1.55, whiteSpace: "pre-wrap", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical" }}>
                    {entry.reflection}
                  </p>
                )}
                {entry.highlightCount > 0 && (
                  <p style={{ margin: 0, fontSize: 12, color: "#9CA3AF" }}>
                    {entry.highlightCount} {entry.highlightCount === 1 ? "trecho marcado" : "trechos marcados"}
                  </p>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
      {renderBottomNav()}
    </div>
  );
}
